// =============================================================================
// MemberStatusAvatar — Avatar that auto-resolves status from UserStatusContext
// Drop-in replacement for Avatar when you have an orgMemberId
// =============================================================================

import * as React from 'react';
import { StatusAvatar, type UserStatus } from './status-avatar';
import { useUserStatusContext } from '@/contexts/UserStatusContext';
import { cn } from '@/lib/utils';

interface MemberStatusAvatarProps {
  orgMemberId?: string | null;
  src?: string | null;
  fallback?: string;
  /** Override status (skip context lookup) */
  status?: UserStatus;
  hideStatus?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const MemberStatusAvatar = React.forwardRef<HTMLDivElement, MemberStatusAvatarProps>(
  ({ orgMemberId, src, fallback, status: overrideStatus, hideStatus, size = 'md', className }, ref) => {
    const { getStatus } = useUserStatusContext();

    const resolvedStatus = overrideStatus ?? (orgMemberId ? getStatus(orgMemberId) : 'available');

    return (
      <StatusAvatar
        ref={ref as any}
        src={src}
        fallback={fallback}
        status={resolvedStatus}
        hideStatus={hideStatus}
        size={size}
        className={className}
      />
    );
  },
);

MemberStatusAvatar.displayName = 'MemberStatusAvatar';
